import React from 'react';
import styled from 'styled-components';

import mailWhite from '../../../png/mailWhite.png';
import phoneWhite from '../../../png/phoneWhite.png';
import close from '../../../svg/close-white.svg';
import { WrongPasswordSupportAlert } from './styled';

const Close = styled.img`
  width: 20px;
  position: absolute;
  top: 2px;
  right: 2px;
  cursor: pointer;
  transition: 0.3s ease-in-out;
  opacity: 0.7;
  &:hover {
    opacity: 1;
  }
`;

const ErrorBlock: React.FC<{ isVisible: boolean; onClose(): void }> = (props) => {
  const phoneNumber = '+38 (067) 405 26 32';
  const mail = 'saynschuman@gmail.com';

  return (
    <WrongPasswordSupportAlert isVisible={props.isVisible}>
      <div className="error-header">Возникли проблемы?</div>
      <div className="error-main">Обратитесь в нашу службу</div>
      <div className="error-main-2">технической поддержки</div>
      <div className="error-phone">
        <img src={phoneWhite} alt="phone" />
        <div>{phoneNumber}</div>
      </div>

      <div className="error-mail">
        <img src={mailWhite} alt="mail" />
        <div>
          <a href={`mailto:${mail}`}>{mail}</a>
        </div>
      </div>
      <Close src={close} alt="close" onClick={props.onClose} />
    </WrongPasswordSupportAlert>
  );
};

export default ErrorBlock;
